/*
 * This service use for defining common function which is used
 * throughout application
 */

/*
 * Import moment plugin for date manipulation functionality
 */
/* eslint-disable */
import moment from 'moment';
import store from '../store/store';
import route from '../router/index';
import { routeDictionary, carrierDetailsArray, pendingRC2FlowCarrierArr } from '../../config/dictionaries/product-navigation';

const commonService = {
  /**
   * This function used to get actual route name from
   * navigation url returned by API
   * @param {*} url navigation url
   * return acutal route name mapped at front end
   */
  getRouteName(url) {
    const urlArray = url.split('/');
    for (let i = 0; i < urlArray.length - 1; i += 1) {
      if (routeDictionary[urlArray[i].toLowerCase()]) {
        return routeDictionary[urlArray[i].toLowerCase()];
      }
    }

    return 'search';
  },
  /**
   * This function used to find whether element exist in array or not
   * @param {*} arr Array in which element need to find based on value
   * @param {*} element element which need to find, its value in array
   */
  elementExist(arr, element) {
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i] === element) {
        return true;
      }
    }
    return false;
  },
  /**
   * This function used to get form post request.
   * It pulls all form data from global pageData array
   * returned object of field name and field value pair
   * @param {*} pageData global page data object from pageData API response
   */
  getFormData(pageData) {
    const pageDataArr = [];
    if (pageData.fields) {
      for (let pCnt = 0; pCnt < pageData.fields.length; pCnt += 1) {
        //store value of QTE_PRP_FinancialInterest in session storage to manage redirection from carrier match page to RC2 flow 
        if (pageData.fields[pCnt].field_name === 'QTE_PRP_FinancialInterest') {
          sessionStorage.setItem('mortgageCheck', pageData.fields[pCnt].field_value);
        }
        // skip iteration if field type is label as we dont need to send static field data to api
        /* eslint no-continue:  */

        if (pageData.fields[pCnt].field_type === 'label') {
          continue;
        }
        /* eslint no-param-reassign: */
        // TODO: Remove this and handle date data according to spec.
        if (pageData.fields[pCnt].field_type === 'date_mmyyyy') {
          pageData.fields[pCnt].field_value = moment(pageData.fields[pCnt].field_value, 'MM/YYYY').format('MMYYYY');
        }
        // remove some special chars from county field. 
        if (pageData.fields[pCnt].field_name === 'QTE_PRP_County' || pageData.fields[pCnt].field_name === 'QTE_ResidenceCounty') {
          pageData.fields[pCnt].field_value = pageData.fields[pCnt].field_value.replace("'","");
        }

        /**
         * If field type is date then date format need to pass to api is YYYYMMDD
         * Front end accepting date in MM/DD/YYYY format which need to convert to YYYYMMDD
         * before passing to API
         */
        if (pageData.fields[pCnt].field_type === 'date_long' || pageData.fields[pCnt].field_type === 'date_short' || pageData.fields[pCnt].field_type === 'date_long_pii') {
          let dateVal = pageData.fields[pCnt].field_value;
          dateVal = moment(dateVal, 'MM/DD/YYYY').format('YYYYMMDD');
          if (!moment(dateVal, 'YYYYMMDD').isValid()) {
            dateVal = '';
          }
          const tempPostData = {
            field_name: pageData.fields[pCnt].field_name,
            field_value: dateVal,
          };
          if (pageData.fields[pCnt].visible) {
            pageDataArr.push(tempPostData);
          }
        } else if (pageData.fields[pCnt].field_type === 'radio_single') {
          if(sessionStorage.getItem('flowType') === 'bundle' && pageData.fields[pCnt].field_name === 'QTE_PRP_BillPlan') {
            const tempPostData = {
              field_name: pageData.fields[pCnt].field_name,
              field_value: store.getters.getHomeBillingPlan,
            };
            pageDataArr.push(tempPostData);
          } else if (pageData.fields[pCnt].field_name === 'QTE_BillPlan' || pageData.fields[pCnt].field_name === 'QTE_PRP_BillPlan') {
            // store.getters.getPageName,
            const tempPostData = {
              field_name: pageData.fields[pCnt].field_name,
              field_value: store.getters.getBillingPlan,
            };
            pageDataArr.push(tempPostData);
          }
        } else {
          const tempPostData = {
            field_name: pageData.fields[pCnt].field_name,
            field_value: pageData.fields[pCnt].field_value,
          };
          if (pageData.fields[pCnt].visible) {
            pageDataArr.push(tempPostData);
          }
        }
      }
    }
    return pageDataArr;
  },
  /**
   * This function pull and returns continue button url from pageData API context
   * @param {*} buttonData ButtonData from pageData API response
   * returns url which will get call on submit button on each form
   */
  getContinueSubmitUrl(buttonData) {
    for (let iCnt = 0; iCnt < buttonData.length; iCnt += 1) {
      /**
       * IF button name is ContinueButton then return url for same node
       */
      if (buttonData[iCnt].name === 'ContinueButton') {
        return buttonData[iCnt].on_click;
      }
    }
    return true;
  },
  /**
   * This function used to reutned label on Continue button.
   * @param {*} buttonData Accepts buttonData node from pageData API response
   * returns submit button label for all forms
   */
  getContinueLabelName(buttonData) {
    for (let iCnt = 0; iCnt < buttonData.length; iCnt += 1) {
      /**
       * IF button name is ContinueButton then return label for same node
       */
      if (buttonData[iCnt].name === 'ContinueButton') {
        return buttonData[iCnt].label;
      }
    }
    return true;
  },
  /**
   * This function used to reutned status of Continue button.
   * @param {*} buttonData Accepts buttonData node from pageData API response
   * returns submit button status for all forms
   */
  getContinueSubmitStatus(buttonData) {
    for (let iCnt = 0; iCnt < buttonData.length; iCnt += 1) {
      /**
       * IF button name is ContinueButton then return status for same node
       */
      if (buttonData[iCnt].name === 'ContinueButton') {
        return buttonData[iCnt].status;
      }
    }
    return true;
  },
  /**
   * To record page load timings in GA
   * @param {*} pageName
   */
  gapRecordAnalytics(pageName) {
    /* eslint no-undef:  */
    /* eslint prefer-template: */
    const pageStartTime = store.getters.getStartTime;
    const pageActionName = store.getters.getPageAction;
    const pageLoadEnd = new Date().getTime();
    const loadTime = (pageLoadEnd - pageStartTime);
    let eName = 'LoadTime';
    let productType = '';
    if (route.currentRoute.path.toLowerCase().includes('/auto/')) {
      productType = 'Auto_';
    } else if (route.currentRoute.path.toLowerCase().includes('/home/')) {
      productType = 'Home_';
    } else if (route.currentRoute.path.toLowerCase().includes('/condo/')) {
      productType = 'Condo_';
    } else if (route.currentRoute.path.toLowerCase().includes('/renter/')) {
      productType = 'Renter_';
    }
    if (pageActionName !== '') {
      eName = 'LoadTime_' + pageActionName;
    }
    // load_time = parseInt( load_time / 100 )*100;
    // console.log(pageStartTime, pageLoadEnd, 'load time', loadTime, pageName, eName);
    if (pageName !== '') {
      gtag('event', 'timing_complete', {
        name: eName,
        event_category: productType + pageName + '_QRP',
        value: loadTime,
      });
    }
    store.dispatch('setPageActionName', '');
  },
  /**
   * Placeholder function To record page load timings in GA (generic)
   * this will eventually remove above function
   * @param {*} pageName
   */
  gapRecordAnalyticsGeneric(pageStartTime, pageActionName, pageName) {
    /* eslint no-undef:  */
    /* eslint prefer-template: */
    const pageLoadEnd = new Date().getTime();
    const loadTime = (pageLoadEnd - pageStartTime);
    let eName = 'LoadTime';
    if (pageActionName !== '') {
      eName = 'LoadTime_' + pageActionName;
    }
    let productType = '';
    if (route.currentRoute.path.toLowerCase().includes('/auto/')) {
      productType = 'Auto_';
    } else if (route.currentRoute.path.toLowerCase().includes('/home/')) {
      productType = 'Home_';
    } else if (route.currentRoute.path.toLowerCase().includes('/condo/')) {
      productType = 'Condo_';
    } else if (route.currentRoute.path.toLowerCase().includes('/renter/')) {
      productType = 'Renter_';
    }
    // load_time = parseInt( load_time / 100 )*100;
    if (pageName !== '') {
      gtag('event', 'timing_complete', {
        name: eName,
        event_category: productType + pageName + '_QRP',
        value: loadTime,
      });
    }
  },
  /**
   * check permission based on role
   */
  checkPermission(role) {
    const permission = sessionStorage.getItem('permissions');
    if (permission) {
      const rightsArr = sessionStorage.getItem('permissions').split(',');
      for (let cnt = 0; cnt <= rightsArr.length; cnt += 1) {
        if (rightsArr[cnt] === role) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * This function used to get carrier details by carrier code
   */
  getCarrierDetails(carrierCode) {
    if (typeof carrierDetailsArray[carrierCode.toLowerCase()] !== 'undefined') {
      return carrierDetailsArray[carrierCode.toLowerCase()];
    }
    return '';
  },
  /**
   * THis fucntion is return true if carrier ID is present in pendingRC2FlowCarrierIDArr
   */
  ispendingRC2FlowForCarrier(carrier, carrierType) {
    /* eslint-disable */
    if (carrierType === 'home') {
      return pendingRC2FlowCarrierArr['home'].includes(carrier);
    }
    return pendingRC2FlowCarrierArr['auto'].includes(carrier);
  },
};

/**
 * export service to used by different components
 */
export default commonService;



// WEBPACK FOOTER //
// ./src/services/common.js